import { useMemo } from 'react';
import { useCreateCase as S } from './contact-channels60.js';

function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target};return _extends.apply(this,arguments)}const n=()=>{const e=S();return useMemo(()=>({createCaseAction:_extends({},e)}),[e])};

export { n as useEmailActions };
//# sourceMappingURL=contact-channels11.js.map
